import { of as observableOf, Observable, ObservedValueOf, of } from 'rxjs';

import { map, mergeMap } from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { HrTranslateService } from './hr-translate.service';
import { UserService } from './user.service';
import { AuthService } from './auth.service';
import { LocalDataStorageService } from './local-data-storage.service';

@Injectable()
export class ApplicationStartupService {
  private isApplicationLoaded: boolean = false;
  private defaultLang: string = 'ka';

  public LoadApplication(): Observable<boolean> {
    if (!this.isApplicationLoaded) {

      let currentLanguage = this.defaultLang;

      if(this.storage.isUiLanguageSet()){
        currentLanguage = this.storage.getUiLanguage();
      }
      else{
        this.storage.setUiLanguage(this.defaultLang);
      }
      
      return this.translateService
        .init({ defaultLang: this.defaultLang, useLang: currentLanguage })
        .pipe(
          mergeMap((t) => {

            let result: Observable<boolean> = of(true);
            if( this.authService.isSignedIn()){
              result = this.userService.loadCurrentUser().pipe(map(c => true));
            }

            return result;
          }),
          map((t) => (this.isApplicationLoaded = true))
        );
    }

    return observableOf(true);
  }

  public isLoaded() {
    return this.isApplicationLoaded;
  }

  constructor(
    private translateService: HrTranslateService,
    private userService: UserService,
    private authService: AuthService,
    private storage: LocalDataStorageService
  ) {}
}
